import { CardActionArea, SxProps, useTheme } from '@mui/material'
import { TBetOperator } from '@pturf-betin/betin-models-lib'
import { OperatorBetType, FlexBox, AlertDialog } from 'components/atoms'
import { useBetContext } from 'contexts/BetContext'
import { useTranslation } from 'contexts/TranslationContext'
import { TBetType } from 'models/betTypes'
import { useState } from 'react'

export const BetTypeSelector = ({
    operator,
    sx
}: {
    operator: TBetOperator
    sx?: SxProps
}) => {
    const theme = useTheme()
    const [selectedBetTypeDisabled, setSelectedBetTypeDisabled] =
        useState(false)

    const {
        availableBetTypes,
        selectedBetType,
        setSelectedBetType,
        handleTrackingEvent
    } = useBetContext()
    const translation = useTranslation()

    const handleClick = (betType: TBetType) => {
        if (betType !== 'S' && operator !== 'PMU')
            return setSelectedBetTypeDisabled(true)

        setSelectedBetType(betType)
        void handleTrackingEvent({
            eventType: 'BET_TYPE',
            actionType: betType
        })
    }

    if (!availableBetTypes.length) return null
    return (
        <>
            <FlexBox
                sx={{
                    width: '100%',
                    flexWrap: 'wrap',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    backgroundColor: 'white',
                    borderRadius: theme.spacing(1),
                    ...sx
                }}
            >
                {availableBetTypes.map((betType) => (
                    <FlexBox
                        sx={{
                            mx: 0.5,
                            minHeight: 33,
                            alignItems: 'flex-start',
                            filter:
                                selectedBetType === betType
                                    ? 'none'
                                    : 'grayscale(0.25)',
                            opacity: selectedBetType === betType ? 1 : 0.25
                        }}
                        key={`${operator}-bet-type-${betType}`}
                    >
                        <CardActionArea onClick={() => handleClick(betType)}>
                            <OperatorBetType
                                betType={betType}
                                operator={operator}
                                big
                            />
                        </CardActionArea>
                    </FlexBox>
                ))}
            </FlexBox>
            <AlertDialog
                visible={selectedBetTypeDisabled}
                onClose={() => setSelectedBetTypeDisabled(false)}
                description={translation.betTypeDisabled}
            />
        </>
    )
}
